import type { ThemeConfig } from 'antd';

declare module 'antd/es/theme/interface' {
  // The design system carries one token of its own alongside antd's.
  interface AliasToken {
    tertiaryColor700: string;
  }
}
import { LookEntity } from '@seaters/constants';
import {
  alertColor,
  baseColor200,
  baseColor300,
  baseColor400,
  baseColor700,
  baseColor900,
  colorBgBaseDark,
  colorBgBaseLight,
  colorTextBaseDark,
  colorTextBaseLight,
  colorTextDescription,
  errorColor400,
  errorColor700,
  primaryColor,
  primaryColor200,
  primaryColor900,
  tertiaryColor700,
} from './colors';
import { getSlugFromUrl, queryClient } from '@seaters/data-access';

const fanGroupData: LookEntity | undefined = queryClient
  .getQueryCache()
  .find<LookEntity>({ queryKey: ['users', 'look'], exact: false })?.state.data;

const primaryCustomColor = fanGroupData?.color;
const slug = getSlugFromUrl();

const fontFamily = 'Inter, sans-serif;';

const commonTheme = {
  fontFamily: fontFamily,
};

export const lightTheme: ThemeConfig = {
  token: {
    ...commonTheme,
    colorPrimary:
      primaryCustomColor && slug ? primaryCustomColor : primaryColor,
    colorBgBase: colorBgBaseLight,
    colorBgLayout: colorBgBaseLight,
    colorTextBase: colorTextBaseLight,
    colorError: errorColor700,
    colorWarning: alertColor,
    colorTextSecondary: colorTextDescription,
    colorTextDescription: colorTextDescription,
    colorBgTextActive: primaryColor200,
    colorLink: colorTextBaseLight,
    colorLinkHover: colorTextBaseLight,
    colorLinkActive: colorTextBaseLight,
    colorBorder: baseColor400,
    colorBorderSecondary: baseColor300,
    colorPrimaryBg: baseColor200,
    tertiaryColor700: tertiaryColor700,
    colorTextDisabled: colorTextDescription,
  },
};

export const darkTheme: ThemeConfig = {
  token: {
    ...commonTheme,
    colorPrimary: primaryColor,
    colorBgBase: colorBgBaseDark,
    colorBgLayout: colorBgBaseDark,
    colorTextBase: colorTextBaseDark,
    colorError: errorColor400,
    colorWarning: alertColor,
    colorTextSecondary: primaryColor200,
    colorBgTextActive: primaryColor900,
    colorLink: colorTextBaseDark,
    colorLinkHover: colorTextBaseDark,
    colorLinkActive: colorTextBaseDark,
    colorBorder: baseColor700,
    colorBorderSecondary: baseColor700,
    colorPrimaryBg: baseColor900,
    tertiaryColor700: tertiaryColor700,
    colorTextDisabled: colorTextDescription,
  },
};
